import type { IBrandingRepository } from '../../domain/repositories/IBrandingRepository';
import type { BrandingConfigDTO } from '../dto/BrandingConfigDTO';
import { BrandingConfig } from '../../domain/entities/BrandingConfig';

/**
 * Use case for retrieving workspace branding configuration
 * Returns default branding if none exists
 */
export class GetBrandingUseCase {
  constructor(private readonly repository: IBrandingRepository) {}

  async execute(workspaceId: number): Promise<BrandingConfigDTO> {
    const branding = await this.repository.getBranding(workspaceId);

    if (!branding) {
      // Return default branding if none exists
      const defaultConfig = BrandingConfig.createDefault(workspaceId);
      return defaultConfig.toJSON();
    }

    return branding;
  }
}
